<div class="ui-g-12">
  <h1>Sposta i canali ed ordinali per priorità</h1>
  <div class="ui-g-12">
    <div class="flex">
      <h2 class="campaign-sub">Canali</h2>
      <h2 class="campaign-sub">Priorità</h2>
    </div>  
    <div class="flex">
        <div class="container channels-list" dragula="CHANNELS" [(dragulaModel)]="channelsList">
          <div class="channel" *ngFor="let channel of channelsList">{{ channel.name }}</div>
        </div>

        <div class="container priorities-list" dragula="CHANNELS" [(dragulaModel)]="priorityList">
          <div class="channel" *ngFor="let priority of priorityList">{{ priority.name }}
            <input type = "hidden" [name]="priority.name" [value]="priority.value" />
          </div>    
        </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-2/drag-and-drop-list/drag-and-drop-list.component.html